module.exports = __webpack_public_path__ + "img/color_icon.7acc8420.svg";